// 아래 함수는 화살표 아이콘 클릭 시 팝업을 띄우는 함수.
// 다시 클릭 시 팝업을 닫는 것을 구현할 방법을 찾지 못하고 일단 열기만 가능.
// 판매처, 타입, PO 번호, 보관위치, 세부위치
export const openSuggestions = (dataType: string) => {
  let elAutoComplete;
  switch (dataType) {
    case 'vendorName':
      elAutoComplete = document.getElementsByClassName('input-vendor-name')[0];
      const elInputVendorName = elAutoComplete.firstElementChild!.firstElementChild as HTMLElement;
      elInputVendorName.focus();
      break;
    case 'manufacturerName':
      elAutoComplete = document.getElementsByClassName('input-manufacturer-name')[0];
      const elInputManufacturerName = elAutoComplete.firstElementChild!
        .firstElementChild as HTMLElement;
      elInputManufacturerName.focus();
      break;
    case 'typeName':
      elAutoComplete = document.getElementsByClassName('input-type-name')[0];
      const elInputTypeName = elAutoComplete.firstElementChild!.firstElementChild as HTMLElement;
      elInputTypeName.focus();
      break;
    case 'grantName':
      elAutoComplete = document.getElementsByClassName('input-grant-name')[0];
      const elInputGrantName = elAutoComplete.firstElementChild!.firstElementChild as HTMLElement;
      elInputGrantName.focus();
      break;
    case 'addressName':
      elAutoComplete = document.getElementsByClassName('input-address-name')[0];
      const elInputAddressName = elAutoComplete.firstElementChild!.firstElementChild as HTMLElement;
      elInputAddressName.focus();
      break;
    case 'poName':
      elAutoComplete = document.getElementsByClassName('input-po-name')[0];
      const elInputPOName = elAutoComplete.firstElementChild!.firstElementChild as HTMLElement;
      elInputPOName.focus();
      break;
    case 'location':
      elAutoComplete = document.getElementsByClassName('input-location')[0];
      const elInputLocation = elAutoComplete.firstElementChild!.firstElementChild as HTMLElement;
      elInputLocation.focus();
      break;
    case 'subLocation':
      elAutoComplete = document.getElementsByClassName('input-sub-location')[0];
      const elInputSubLocation = elAutoComplete.firstElementChild!.firstElementChild as HTMLElement;
      elInputSubLocation.focus();
      break;
    default:
      break;
  }
};
